import { RouteType } from "types/RouteType";
import ProductRoute from "./Product.Route";
import productCategoriesRoute from "./ProductCategories/ProductCategories.Route";
import productManagementRoute from "./ProductManagement/ProductManagement.Route";
import productDrawingManagementRoute from "./DrawingManagement/DrawingManagement.Route";

/**
 * Product Routes List
 */
const productRoutesList: RouteType[] = [
  // =========================================================================
  // ACTIVE ROUTES - Currently in use
  // =========================================================================
  ProductRoute,
  productCategoriesRoute,

  // =========================================================================
  // HIDDEN ROUTES - Not currently in use but available for future use
  // To re-enable: uncomment the route below and it will appear in navigation
  // =========================================================================
  // productManagementRoute,         // Product management interface
  // productDrawingManagementRoute,  // Drawing management interface
];

export default productRoutesList;
